import { render, staticRenderFns } from "./recommendGood.vue?vue&type=template&id=1900f003&scoped=true"
import script from "./recommendGood.vue?vue&type=script&lang=js"
export * from "./recommendGood.vue?vue&type=script&lang=js"
import style0 from "./recommendGood.vue?vue&type=style&index=0&id=1900f003&prod&lang=scss&scoped=true"
import style1 from "./recommendGood.vue?vue&type=style&index=1&id=1900f003&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900f003",
  null
  
)

export default component.exports